import { render, staticRenderFns } from "./PlaceForm.vue?vue&type=template&id=69f53e66&"
import script from "./PlaceForm.vue?vue&type=script&lang=js&"
export * from "./PlaceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports